export const data = {
  description: "Si no estás de acuerdo con alguno de los datos que aparecen en tu historial de crédito, puedes solicitar una revisión al Buró de crédito.",
  steps: [
    "Enviamos tu solicitud al Buró.",
    "Mientras el Buró la revisa, incluimos una nota en tu historial indicando que está en revisión.",
    "Al final te ayudaremos a tramitar la corrección ante el Buró y haremos seguimiento a tus solicitudes.",
  ]
};
